module.exports = __webpack_public_path__ + "img/etsy.100a5743.jpg";